/**
 * @module 同居家族追加ダイアログコンポーネント
 */
import { relationship } from '../../computed';

export default {
  name: 'AddFamilyModal',
  props: ['dialog', 'valid', 'error', 'appendAlertClass', 'relationship', 'sortFlag'],
  data(vm) {
    return {
      childDialog: this.dialog,
      childValid: this.valid,
      displayDialog: false,
      dateMenu: false,
      person: {
        id: 0,
        name: '',
        nameKana: '',
        relationship: null,
        relationshipOther: '',
        birthday: '',
      },
      rules: {
        // 氏名
        name: [
          // 必須チェック
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0006'
            ),
        ],
        // 氏名（カナ）
        nameKana: [
          // 必須チェック
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0008'
            ),
          // 全角カナチェック
          (value) =>
            (!!value && /^[ァ-ヶー]+$/.test(value)) ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0010'
            ),
        ],
        // 続柄
        relationship: [
          // 必須チェック
          (value) => {
            if (value === '' || value === null || value === undefined) {
              return vm.$vuetify.lang.t(
                '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0011'
              );
            } else {
              return true;
            }
          },
        ],
        // 続柄（その他）
        relationshipOther: [
          // 必須チェック
          (value) => {
            if ((value === '' || value === null) && this.person.relationship === 99) {
              return vm.$vuetify.lang.t(
                '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0012'
              );
            } else {
              return true;
            }
          },
        ],
        // 生年月日
        birthday: [
          // 必須チェック
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0014'
            ),
        ],
      },
    };
  },
  created() {
    this.person.relationship = null;
  },
  computed: {
    dateShow: {
      get() {
        return this.formatDate(this.person.birthday);
      },
    },
    disabled() {
      return (
        !this.childValid ||
        !this.person.name ||
        !this.person.nameKana ||
        this.person.relationship === null ||
        !this.person.birthday
      );
    },
    i18nItems(vm) {
      return {
        relationshipList: relationship(vm),
      };
    },
    today() {
      return new Date()
        .toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .split('/')
        .join('-');
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * キャンセルボタン押下時処理
     */
    closeModal() {
      this.childDialog = false;
      setTimeout(() => {
        this.displayDialog = false;
      }, 200);
    },
    /**
     * ダイアログ表示処理
     */
    openModal() {
      this.personClear();
      this.displayDialog = true;
    },
    /**
     * 生年月日フォーマット処理
     * @param {Date} date 生年月日
     * @returns 生年月日(YY/mm/dd)
     */
    formatDate(date) {
      if (date === '') {
        return '';
      }
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      return year + '/' + month + '/' + day + '';
    },
    /**
     * 初期化処理
     */
    personClear() {
      this.person.name = '';
      this.person.nameKana = '';
      this.person.relationship = null;
      this.person.birthday = '';
    },
    /**
     * 登録ボタン押下時処理
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.addPerson();
      }
    },
    /**
     * 登録ボタン押下時処理呼び出し処理
     */
    addPerson() {
      this.$emit('add-person', this.person);
      this.closeModal();
    },
    /**
     * その他続柄入力フォーム初期化処理
     */
    relationshipOtherClear() {
      if (this.person.relationshipOther !== 99) {
        this.person.relationshipOther = '';
      }

      // フォーカスをあてないとバリエーションチェックをしないため、その他を選択したらフォーカスをあてる
      if (this.person.relationship === 99) {
        this.$nextTick(() => this.$refs.relationshipOtherText.focus());
        this.$refs.relationshipSelect.blur();
      }
    },
  },
};
